<div class="modal-box assign-tag-modal" cdkDrag>
    <form class="assign-tag-modal__form modal-form" [formGroup]="assignTagForm" (ngSubmit)="onSubmit()">
        <div class="modal-header assign-tag-modal__header" cdkDragHandle>
            <div class="assign-tag-modal__headline modal-headline">
                <span class="assign-tag-modal__eyebrow modal-eyebrow">{{ 'TAGS' | translate }}</span>
                <h4 class="modal-title assign-tag-modal__title modal-heading">{{ 'ASSIGN_TAGS' | translate }}</h4>
            </div>
            <button type="button" class="assign-tag-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body assign-tag-modal__body">
            <div class="assign-tag-modal__sections modal-sections">
                <section class="assign-tag-modal__panel modal-panel">
                    <div class="assign-tag-modal__field modal-field">
                        <label class="assign-tag-modal__label modal-label" for="tagIds">{{ 'SELECT_TAGS' | translate }}</label>
                        <ng-select id="tagIds" class="assign-tag-modal__select modal-select" [ngClass]="{ 'is-invalid': submitted && f.tagIds.errors }" [multiple]="true" formControlName="tagIds">
                            <ng-option *ngFor="let tag of allTags" [value]="tag.id">{{ tag.name }}</ng-option>
                        </ng-select>
                        <div *ngIf="submitted && f.tagIds.errors" class="assign-tag-modal__feedback modal-feedback">
                            <div *ngIf="f.tagIds.errors.required">{{ 'PLEASE_SELECT_TAGS' | translate }}</div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer assign-tag-modal__footer" cdkDragHandle>
            <div class="assign-tag-modal__actions modal-actions">
                <button type="button" class="red-outline-button assign-tag-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CLOSE' | translate }}</button>
                <button type="submit" class="blue-button assign-tag-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
